enum ImageSizes {
    XSmall = "24",
    Small = "30",
    XMedium = "40",
    Medium = "60",
    XLarge = "220",
    XXLarge = "240"
}

export default ImageSizes;